import { MODEL_OPTIONS, type AgentKind } from "../models";

interface Props {
  value: string;
  onChange: (model: string) => void;
  disabled?: boolean;
  /** Motor atual (claude/codex) - só mostra os modelos desse motor. */
  agent?: AgentKind;
  /** Modelos que a pessoa tem permissão de usar (controlado pelo admin). Default: todos. */
  allowed?: string[];
}

/**
 * Seletor de modelo da conversa. A escolha vale a partir da próxima mensagem
 * e fica persistida na sessão. "Padrão do servidor" não envia override. Só
 * mostra os modelos do motor atual (`agent`) que a pessoa tem permissão de
 * usar (`allowed`).
 */
export function ModelSelector({ value, onChange, disabled, agent = "claude", allowed }: Props) {
  const byAgent = MODEL_OPTIONS.filter((m) => m.agent === agent);
  const options = allowed?.length ? byAgent.filter((m) => allowed.includes(m.id)) : byAgent;
  const known = options.some((m) => m.id === value);
  return (
    <label className="model-selector" title="Modelo usado nas próximas respostas desta conversa">
      <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M8 1.5l5.5 3v7L8 14.5 2.5 11.5v-7L8 1.5z" />
        <path d="M8 8l5.5-3M8 8v6.5M8 8L2.5 5" />
      </svg>
      <select
        value={known ? value : value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || options.length <= 1}
        aria-label="Modelo"
      >
        {!known && value && <option value={value}>{value}</option>}
        {options.map((m) => (
          <option key={m.id || "default"} value={m.id} title={m.hint}>
            {m.label}
          </option>
        ))}
      </select>
    </label>
  );
}
